import React from "react";
import { Button, Paper, TextField, MenuItem, Grid } from "@mui/material";
import { useMutation, useQuery } from "@apollo/client";
import { useFormik } from "formik";
import * as Yup from "yup";
import { AGREGAR_BANCO, LISTAR_BANCOS } from "../../../../graphql/bancos";
const FrmAgregarBanco = ({ setOpenDialog, setOpenSnackBar, setErrorGraph }) => {
  const [agregarBanco] = useMutation(AGREGAR_BANCO, {
    update(cache, { data: { agregarBanco } }) {
      const { obtenerListaBancos } = cache.readQuery({
        query: LISTAR_BANCOS,
      });
      cache.writeQuery({
        query: LISTAR_BANCOS,
        data: {
          obtenerListaBancos: [...obtenerListaBancos, agregarBanco],
        },
      });
    },
  });

  //Formik
  const formik = useFormik({
    initialValues: {
      banco: "",
      nocuenta: "",
      clabe: "",
      montoapertura: 0
    },
    validationSchema: Yup.object({
      banco: Yup.string().required("El nombre del banco es requerido"),
      nocuenta: Yup.string().required("El No. de cuenta es requerido"),
    }),
    onSubmit: async (input) => {
      try {
        const result = await agregarBanco({
          variables: {
            input: {
              banco: input.banco,
              nocuenta: input.nocuenta,
              clabe: input.clabe,
              montoapertura: parseFloat(input.montoapertura)
            },
          },
        });
        setOpenSnackBar(true);
        setErrorGraph({
          mensaje: result.data.agregarBanco,
          severity: "success",
        });
        //Si todo sale bien reseteamos el formulario
        formik.resetForm();
      } catch (error) {
        setOpenSnackBar(true);
        setErrorGraph({ mensaje: error.message, severity: "error" });
      }
    },
  });
  const handleOpenDialog = () => {
    setOpenDialog(false);
    //setOpenSnackBar(true);
  };

 
  return (
    <form onSubmit={formik.handleSubmit}>
      <Paper style={{ padding: 10 }}>
        <Grid container alignItems="flex-start" spacing={3}>
          <Grid item xs={12}>
            <TextField
              id="banco"
              label="Banco"
              variant="standard"
              fullWidth
              value={formik.values.banco}
              onChange={formik.handleChange}
            />
            {formik.errors.banco}
          </Grid>
          <Grid item xs={12}>
            <TextField
              id="nocuenta"
              label="No. de Cuenta"
              variant="standard"
              fullWidth
              value={formik.values.nocuenta}
              onChange={formik.handleChange}
            />
            {formik.errors.nocuenta}
          </Grid>
          <Grid item xs={12}>
            <TextField id="clabe" label="CLABE" variant="standard" fullWidth  value={formik.values.clabe}
              onChange={formik.handleChange} />
               {formik.errors.clabe}
          </Grid>
          <Grid item xs={12}>
            <TextField id="montoapertura" label="Monto de Apertura" variant="standard" fullWidth  value={formik.values.montoapertura}
              onChange={formik.handleChange} />
               {formik.errors.montoapertura}
          </Grid>
          
        </Grid>
        
        
      </Paper>
      <Button type="submit">Guardar</Button>
      <Button onClick={() => handleOpenDialog()}>Cerrar</Button>
    </form>
  );
};

export default FrmAgregarBanco;
